import { render, staticRenderFns } from "./portModal.vue?vue&type=template&id=c1a93ba0&scoped=true&"
import script from "./portModal.vue?vue&type=script&lang=js&"
export * from "./portModal.vue?vue&type=script&lang=js&"
import style0 from "./portModal.vue?vue&type=style&index=0&id=c1a93ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a93ba0",
  null
  
)

export default component.exports